// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__wwgjm","dragIcon":"SortableItem_dragIcon__3mWvx","disabled":"SortableItem_disabled__3m-cZ"};